export const staticPrimaryColor = '#28C76F'

// Global styles for filled input fields
export const globalInputStyles = `
  /* Light theme - Filled input fields styling */
  .v-theme--light .v-field--variant-filled .v-field__input:not(:placeholder-shown),
  .v-theme--light .v-field--variant-outlined .v-field__input:not(:placeholder-shown),
  .v-theme--light .v-field--variant-underlined .v-field__input:not(:placeholder-shown),
  .v-theme--light .v-field--variant-filled .v-field__input:focus,
  .v-theme--light .v-field--variant-outlined .v-field__input:focus,
  .v-theme--light .v-field--variant-underlined .v-field__input:focus,
  .v-theme--light .v-field--variant-filled .v-field__input:valid,
  .v-theme--light .v-field--variant-outlined .v-field__input:valid,
  .v-theme--light .v-field--variant-underlined .v-field__input:valid {
    color: #424348 !important;
    font-weight: 600 !important;
    opacity: 1 !important;
  }
  
  /* Light theme - VSelect filled options */
  .v-theme--light .v-select .v-field__input:not(:placeholder-shown),
  .v-theme--light .v-select .v-field__input:focus,
  .v-theme--light .v-select .v-field__input:valid {
    color: black !important;
    font-weight: 600 !important;
    opacity: 1 !important;
  }
  
  /* Light theme - VAutocomplete filled options */
  .v-theme--light .v-autocomplete .v-field__input:not(:placeholder-shown),
  .v-theme--light .v-autocomplete .v-field__input:focus,
  .v-theme--light .v-autocomplete .v-field__input:valid {
    color: black !important;
    font-weight: 600 !important;
    opacity: 1 !important;
  }
  
  /* Light theme - VCombobox filled options */
  .v-theme--light .v-combobox .v-field__input:not(:placeholder-shown),
  .v-theme--light .v-combobox .v-field__input:focus,
  .v-theme--light .v-combobox .v-field__input:valid {
    color: black !important;
    font-weight: 600 !important;
    opacity: 1 !important;
  }
  
  /* Light theme - VTextarea filled content */
  .v-theme--light .v-textarea .v-field__input:not(:placeholder-shown),
  .v-theme--light .v-textarea .v-field__input:focus,
  .v-theme--light .v-textarea .v-field__input:valid {
    color: #424348 !important;
    font-weight: 600 !important;
    opacity: 1 !important;
  }
  
  /* Light theme - Date picker and time picker */
  .v-theme--light .v-date-picker .v-field__input:not(:placeholder-shown),
  .v-theme--light .v-date-picker .v-field__input:focus,
  .v-theme--light .v-date-picker .v-field__input:valid,
  .v-theme--light .v-time-picker .v-field__input:not(:placeholder-shown),
  .v-theme--light .v-time-picker .v-field__input:focus,
  .v-theme--light .v-time-picker .v-field__input:valid {
    color: #424348 !important;
    font-weight: 600 !important;
    opacity: 1 !important;
  }
  
  /* Dark theme - Filled input fields styling */
  .v-theme--dark .v-field--variant-filled .v-field__input:not(:placeholder-shown),
  .v-theme--dark .v-field--variant-outlined .v-field__input:not(:placeholder-shown),
  .v-theme--dark .v-field--variant-underlined .v-field__input:not(:placeholder-shown),
  .v-theme--dark .v-field--variant-filled .v-field__input:focus,
  .v-theme--dark .v-field--variant-outlined .v-field__input:focus,
  .v-theme--dark .v-field--variant-underlined .v-field__input:focus,
  .v-theme--dark .v-field--variant-filled .v-field__input:valid,
  .v-theme--dark .v-field--variant-outlined .v-field__input:valid,
  .v-theme--dark .v-field--variant-underlined .v-field__input:valid {
    color: #fff !important;
    font-weight: 600 !important;
    opacity: 1 !important;
  }
  
  /* Dark theme - VSelect filled options */
  .v-theme--dark .v-select .v-field__input:not(:placeholder-shown),
  .v-theme--dark .v-select .v-field__input:focus,
  .v-theme--dark .v-select .v-field__input:valid {
    color: #fff !important;
    font-weight: 600 !important;
    opacity: 1 !important;
  }
  
  /* Dark theme - VAutocomplete filled options */
  .v-theme--dark .v-autocomplete .v-field__input:not(:placeholder-shown),
  .v-theme--dark .v-autocomplete .v-field__input:focus,
  .v-theme--dark .v-autocomplete .v-field__input:valid {
    color: #fff !important;
    font-weight: 600 !important;
    opacity: 1 !important;
  }
  
  /* Dark theme - VCombobox filled options */
  .v-theme--dark .v-combobox .v-field__input:not(:placeholder-shown),
  .v-theme--dark .v-combobox .v-field__input:focus,
  .v-theme--dark .v-combobox .v-field__input:valid {
    color: #fff !important;
    font-weight: 600 !important;
    opacity: 1 !important;
  }
  
  /* Dark theme - VTextarea filled content */
  .v-theme--dark .v-textarea .v-field__input:not(:placeholder-shown),
  .v-theme--dark .v-textarea .v-field__input:focus,
  .v-theme--dark .v-textarea .v-field__input:valid {
    color: #fff !important;
    font-weight: 600 !important;
    opacity: 1 !important;
  }
  
  /* Dark theme - Date picker and time picker */
  .v-theme--dark .v-date-picker .v-field__input:not(:placeholder-shown),
  .v-theme--dark .v-date-picker .v-field__input:focus,
  .v-theme--dark .v-date-picker .v-field__input:valid,
  .v-theme--dark .v-time-picker .v-field__input:not(:placeholder-shown),
  .v-theme--dark .v-time-picker .v-field__input:focus,
  .v-theme--dark .v-time-picker .v-field__input:valid {
    color: #fff !important;
    font-weight: 600 !important;
  }
  
  /* Vuetify label/placeholder styling */
  .v-theme--light .v-label:not(.v-field-label--floating) {
    color: #ABACB5 !important;
    opacity: 1 !important;
  }
  
  .v-theme--dark .v-label:not(.v-field-label--floating) {
    color: #d0d4f1ad !important;
    opacity: 1 !important;
  }
`

export const themes = {
  light: {
    dark: false,
    colors: {
      'primary': staticPrimaryColor,
      'on-primary': '#fff',
      'secondary': '#A8AAAE',
      'on-secondary': '#fff',
      'success': '#00AD43',
      'on-success': '#fff',
      'info': '#00CFE8',
      'on-info': '#fff',
      'warning': '#FF9F43',
      'on-warning': '#fff',
      'error': '#EA5455',
      'background': '#F8F7FA',
      'on-background': '#2F2B3D',
      'on-surface': '#2F2B3D',
      'grey-50': '#F6F6F6',
      'grey-100': '#EFEFEF',
      'grey-200': '#ABACB5',
      'grey-300': '#ABACB5',
      'grey-400': '#888888',
      'grey-600': '#585962',
      'grey-600': '#5D5D5D',
      'grey-700': '#585962',
      'grey-800': '#424348',
      'grey-900': '#3D3D3D',
      'perfect-scrollbar-thumb': '#DBDADE',
      'skin-bordered-background': '#fff',
      'skin-bordered-surface': '#fff',
    },
    variables: {
      'code-color': '#d400ff',
      'overlay-scrim-background': '#4C4E64',
      'tooltip-background': '#4A5072',
      'overlay-scrim-opacity': 0.5,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.06,
      'activated-opacity': 0.16,
      'pressed-opacity': 0.14,
      'dragged-opacity': 0.1,
      'disabled-opacity': 0.42,
      'border-color': '#2F2B3D',
      'border-opacity': 0.16,
      'high-emphasis-opacity': 0.78,
      'medium-emphasis-opacity': 0.68,
      'switch-opacity': 0.2,
      'switch-disabled-track-opacity': 0.3,
      'switch-disabled-thumb-opacity': 0.4,
      'switch-checked-disabled-opacity': 0.3,

      // Shadows
      'shadow-key-umbra-color': '#2F2B3D',
    },
  },
  dark: {
    dark: true,
    colors: {
      'primary': staticPrimaryColor,
      'on-primary': '#fff',
      'secondary': '#A8AAAE',
      'on-secondary': '#fff',
      'success': '#28C76F',
      'on-success': '#fff',
      'info': '#00CFE8',
      'on-info': '#fff',
      'warning': '#FF9F43',
      'on-warning': '#fff',
      'error': '#EA5455',
      'background': '#25293C',
      'on-background': '#D0D4F1',
      'surface': '#2F3349',
      'on-surface': '#D0D4F1',
      'grey-50': '#26293A',
      'grey-100': '#2F3349',
      'grey-200': '#26293A',
      'grey-300': '#4A5072',
      'grey-400': '#5E6692',
      'grey-600': '#7983BB',
      'grey-600': '#AAB3DE',
      'grey-700': '#B6BEE3',
      'grey-800': '#424348',
      'grey-900': '#E7E9F6',
      'perfect-scrollbar-thumb': '#4A5072',
      'skin-bordered-background': '#2f3349',
      'skin-bordered-surface': '#2f3349',
    },
    variables: {
      'code-color': '#d400ff',
      'overlay-scrim-background': '#101121',
      'tooltip-background': '#5E6692',
      'overlay-scrim-opacity': 0.6,
      'hover-opacity': 0.04,
      'focus-opacity': 0.12,
      'selected-opacity': 0.06,
      'activated-opacity': 0.16,
      'pressed-opacity': 0.14,
      'dragged-opacity': 0.1,
      'disabled-opacity': 0.42,
      'border-color': '#D0D4F1',
      'border-opacity': 0.16,
      'high-emphasis-opacity': 0.78,
      'medium-emphasis-opacity': 0.68,
      'switch-opacity': 0.4,
      'switch-disabled-track-opacity': 0.4,
      'switch-disabled-thumb-opacity': 0.8,
      'switch-checked-disabled-opacity': 0.3,

      // Shadows
      'shadow-key-umbra-color': '#0F1422',
    },
  },
}
export default themes
